import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=f5814138&scoped=true"
import script from "./FacebookLogin.vue?vue&type=script&lang=js"
export * from "./FacebookLogin.vue?vue&type=script&lang=js"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=f5814138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5814138",
  null
  
)

export default component.exports